<template>
  <div>
    <div v-if="process">
      <Loading />
    </div>
    <b-modal  
      v-model="modal_login"
      id="modal-login"
      ref="modal"
      centered
      hide-footer
      hide-header
      content-class="rounded-0"
      no-stacking
      size="sm"
    > 
      <form ref="form" @submit.stop.prevent="handleSubmit" class="font-k2d">
        <b-row class="mt-3">
          <b-col class="text-center">
            <b-img src="../assets/img/logo-V2-2022.png" class="w-50"></b-img>
            <h4 class="mt-3">เข้าสู่ระบบ</h4>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-col class="col-11">
            <b-form-group>
              <b-form-input type="text"
                            v-model="username"
                            placeholder="อีเมล"
              ></b-form-input>
            </b-form-group>
            
            <b-form-group>
              <b-form-input type="password"
                            v-model="password"
                            placeholder="รหัสผ่าน"
              ></b-form-input>
            </b-form-group>

            <b-form-group class="text-center">
              <b-form-radio-group
                v-model="animal"
                :options="animals"
                name="animal-group"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="text-center">
            <b-button type="submit" variant="outline-success" :disabled="username==''&&password==''" pill>เข้าสู่ระบบ</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-4 mb-3" align-h="around">
          <b-col class="text-left">
            <b-button variant="link" v-b-modal.modal-forgot @click="modal_login=false">ลืมรหัสผ่าน</b-button>
          </b-col>
          <b-col class="text-right">
            <b-button variant="link" v-b-modal.modal-register @click="modal_login=false">สมัครสมาชิก</b-button>
          </b-col>
        </b-row>
      </form>
    </b-modal>

    <!-- forgot -->
    <b-modal  
      id="modal-forgot"
      ref="modal"
      centered
      hide-footer
      hide-header
      content-class="rounded-0"
      no-stacking
      size="sm"
    > 
      <form ref="form" @submit.stop.prevent="handleForgot">
        <b-row class="mt-3">
          <b-col class="text-center">
            <b-img src="../assets/img/logo-V2-2022.png" class="w-50"></b-img>
            <h4 class="mt-3">ลืมรหัสผ่านของคุณใช่หรือไม่</h4>
            <h6 class="mt-1">ป้อนอีเมลของคุณและเราจะส่งคำแนะนำในการรีเซ็ตรหัสผ่านของคุณ</h6>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-col class="col-11">
            <b-form-group class="text-center">
              <b-form-radio-group
                v-model="animal"
                :options="animals"
                name="animal-group"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-group>
              <b-form-input 
                type="email"
                v-model="email_forgot"
                placeholder="อีเมล"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="text-center">
            <b-button type="submit" variant="outline-success" :disabled="email_forgot==''" pill>ดำเนินการต่อ</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-4 mb-3">
          <b-col class="text-center">
            <b-button variant="link" v-b-modal.modal-login>เข้าสู่ระบบ</b-button>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
// const domain = "http://localhost:7749"
// const domain = "cpfsmartfarmsolution.com"

export default {
  name: "formLogin",
  components: {
    Loading,
  },
  props: {},
  data() {
    return {
      modal_login: false,
      process: false,
      animal: "",
      animals: [
        {value: "", text: 'สัตว์บก'},
        {value: "/poultry", text: 'สัตว์ปีก'},
        // {value: 3, text: 'สัตว์น้ำ'}
      ],
      username: "",
      password: "",
      name_en: '',
      email_forgot: ""
    };
  },
  mounted() {
    localStorage.removeItem('farm_id')
    localStorage.removeItem('name_th')
    localStorage.removeItem('name_en')
    localStorage.removeItem('user_id')
    localStorage.removeItem('role')
    localStorage.removeItem('access-token')
    localStorage.removeItem('verify-token')
    localStorage.removeItem('customer')
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.process = true
      this.$store.dispatch("retrieveToken", {
        animal: this.animal,
        username: this.username,
        password: this.password,
      })
      .then((response) => {
        if (response.data.success == 1 && parseInt(response.data.user.role) == 1) {
          setTimeout(() => {
            this.process = false
            this.alertResult(`เข้าสู่ระบบ`, `สำเร็จ!`, `success`);
            this.$nextTick(() => {
              this.$router.push({
                name: "home",
              });
            });
          }, 2000)
        }
        else if (response.data.success == 1 && (parseInt(response.data.user.role) == 2 || parseInt(response.data.user.role) == 3)) {
          this.viewFarmActive(response.data.user.farm_id, response.data.user.user_id, response.data.user.role, response.data.token, response.data.verify)          
        } 
        else {
          setTimeout(() => {
            this.process = false
            this.alertResult(`เข้าสู่ระบบ ไม่สำเร็จ!`, response.data.message, `danger`);
          }, 2000)
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },
    viewFarmActive(farm_id, user_id, role, token, verify) {
      var data = []
      this.$store.dispatch('viewFarmActive', {
          animal: this.animal
        })
      .then(response => {
        if(response.data.success == 1) {
          for(let i in response.data.data) {
            data.push(response.data.data[i])
          }          
        }
        this.agencyFarm(farm_id, user_id, role, token, verify, data)
      })
    },
    agencyFarm(farm_id, user_id, role, token, verify, data) {
      this.name_en = ''
      if(data.length != 0) {
        for(let i in data) {
          let farm_token = (data[i].farm_token)
          let agency = farm_token.slice(1, 2)
          let animal = farm_token.slice(2, 3);
          let animal_type = farm_token.slice(3, 4);
          var group = ''
          // const farm_id = parseInt(farm_token.slice(4,7))
          if(agency == '1') {
            group = 'company'
          }
          else if(agency == '2') {
            group = 'promote'
          }

          if(parseInt(data[i].farm_id) == parseInt(farm_id)) {
            if(animal == '1') {
              this.gotoFarmSwine(farm_id, user_id, role, group, token, verify, data[i].name_th, data[i].name_en)
            }
            else if(animal == '2') {
              this.gotoFarmCow(farm_id, user_id, role, group, token, verify, data[i].name_th, data[i].name_en)
            }
            else if(animal == '3' || animal == '4') {
              if(animal_type == '0') {
                this.gotoFarmLayer(farm_id, user_id, role, group, token, verify, data[i].name_th, data[i].name_en)
              }
              else if(animal_type == '1') {
                this.gotoFarmBreed(farm_id, user_id, role, group, token, verify, data[i].name_th, data[i].name_en)
              }
              else if(animal_type == '2') {
                this.gotoFarmBroiler(farm_id, user_id, role, group, token, verify, data[i].name_th, data[i].name_en)
              }
            }
            break
          }
        }          
      }
      else {
        setTimeout(() => {
          this.process = false
          this.alertResult(`เข้าสู่ระบบ ไม่สำเร็จ!`, `Username หรือ Password ไม่ถูกต้อง¡¡¡`, `danger`);
        }, 2000)
      }
    },
    gotoFarmSwine(farm_id, user_id, role, group, token, verify, name_th, name_en) { 
      name_en = name_en.toString()
      name_en = name_en.replace(/_/g, "")
      // window.location = domain + "/" + name + "/redirect/?farm_id=" + farm_id + "&user_id=" + user_id + "&role=" + role + "&token=" + token + "&verify=" + verify
      window.location = "https://www.cpfsmartfarmsolution.com/swine/" + group + "/" + name_en + "/#/redirect/?farm_id=" + farm_id + "&name_th=" + name_th + "&name_en=" + name_en + "&user_id=" + user_id + "&role=" + role + "&token=" + token + "&verify=" + verify
    },
    gotoFarmCow(farm_id, user_id, role, group, token, verify, name_th, name_en) { 
      name_en = name_en.toString()
      name_en = name_en.replace(/_/g, "")
      // window.location = domain + "/" + name + "/redirect/?farm_id=" + farm_id + "&user_id=" + user_id + "&role=" + role + "&token=" + token + "&verify=" + verify
      window.location = "https://www.cpfsmartfarmsolution.com/cow/" + group + "/" + name_en + "/#/redirect/?farm_id=" + farm_id + "&name_th=" + name_th + "&name_en=" + name_en + "&user_id=" + user_id + "&role=" + role + "&token=" + token + "&verify=" + verify
    },
    gotoFarmLayer(farm_id, user_id, role, group, token, verify, name_th, name_en) { 
      name_en = name_en.toString()
      name_en = name_en.replace(/_/g, "")
      // window.location = domain + "/" + name + "/redirect/?farm_id=" + farm_id + "&user_id=" + user_id + "&role=" + role + "&token=" + token + "&verify=" + verify
      window.location = "https://www.cpfsmartfarmsolution.com/layer/" + group + "/" + name_en + "/#/redirect/?farm_id=" + farm_id + "&name_th=" + name_th + "&name_en=" + name_en + "&user_id=" + user_id + "&role=" + role + "&token=" + token + "&verify=" + verify
    },
    gotoFarmBreed(farm_id, user_id, role, group, token, verify, name_th, name_en) { 
      name_en = name_en.toString()
      name_en = name_en.replace(/_/g, "")
      // window.location = domain + "/" + name + "/redirect/?farm_id=" + farm_id + "&user_id=" + user_id + "&role=" + role + "&token=" + token + "&verify=" + verify
      window.location = "https://www.cpfsmartfarmsolution.com/breed/" + group + "/" + name_en + "/#/redirect/?farm_id=" + farm_id + "&name_th=" + name_th + "&name_en=" + name_en + "&user_id=" + user_id + "&role=" + role + "&token=" + token + "&verify=" + verify
    },
    gotoFarmBroiler(farm_id, user_id, role, group, token, verify, name_th, name_en) { 
      name_en = name_en.toString()
      name_en = name_en.replace(/_/g, "")
      // window.location = domain + "/" + name + "/redirect/?farm_id=" + farm_id + "&user_id=" + user_id + "&role=" + role + "&token=" + token + "&verify=" + verify
      window.location = "https://www.cpfsmartfarmsolution.com/broiler/" + group + "/" + name_en + "/#/redirect/?farm_id=" + farm_id + "&name_th=" + name_th + "&name_en=" + name_en + "&user_id=" + user_id + "&role=" + role + "&token=" + token + "&verify=" + verify
    },
    handleForgot(e) {
      e.preventDefault();
      this.process = true
      this.$store.dispatch("Forgot", {
        animal: this.animal,
        username: this.email_forgot
      })
      .then((response) => {
        if(response.data.success == 1) {
          setTimeout(() => {
            this.process = false
            this.alertResult(`สำเร็จ`, `กรุณาตรวจสอบอีเมลของคุณ!`, `success`);
          }, 2000)
        } 
        else {
          this.loginFaild(response.data.message)
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },
    loginFaild(message) {
      setTimeout(() => {
        this.process = false
        this.alertResult(`เข้าสู่ระบบ ไม่สำเร็จ!`, message, `danger`);
      }, 2000)
    },
    alertResult(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 5000,
        appendToast: false,
        variant: variant,
        toaster: "b-toaster-bottom-right",
        solid: true,
      });
    },
  },
};
</script>

<style >
/* html, body {
  font-family: 'Athiti';
  font-size: 0.9rem;
  height: 100%;
  background-color: #030730 !important;
} */

</style>
